//eslint-disable-next-line
export const EmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

//eslint-disable-next-line
export const PasswordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-'\/`~!#*$@_%+=.,^&(){}[\]|;:"<>?\\])(?=.{8,})/;

// +1 123 4567890
// +11234567890
// +1(123)4567890
// +1(123)456-7890
// +1 (123) 456-7890
// +1 (123)456 7890
// +1 123 456-7890
// +1 123 456 7890
// +1 123-456-7890
// 123-456-7890
// 123 456-7890
// 123 456 7890
// 123 4567890
// 1234567890

//eslint-disable-next-line
export const PhoneRegex = /^[\+]?([0-9][\s]?|[0-9]?)([(][0-9]{3}[)][\s]?|[0-9]{3}[-\s\.]?)[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;

//eslint-disable-next-line
export const PhoneRegexAlt = /^\d{3}-?\d{3}-?\d{4}$/;

export const E164PhoneRegex = /^\+[1-9]\d{6,14}$/;

//eslint-disable-next-line
export const DobRegex = /^(0[1-9]|1[012])[- /.](0[1-9]|[12][0-9]|3[01])[- /.](19|20)\d\d$/;

//eslint-disable-next-line
export const SsnRegex = /^\d{3}-?\d{2}-?\d{4}$/;

//eslint-disable-next-line
export const UrlRegex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;

//eslint-disable-next-line
export const BankRoutingNumberRegex = /^[0123][0-9]+$/;

//eslint-disable-next-line
export const NumberRegex = /^[0-9\b]+$/;

//eslint-disable-next-line
export const cardExpirationDateRegex = /^\d{2}\/?\d{4}$/;

export const fileExtensionRemovalRegex = /\.[^/.]+$/;

export const camelCaseRemovalRegex = /([a-z])([A-Z])/g;

//regular expression to find placeholder keys in string eg: {{any_string_that_match}}
export const placeholderKeyRegex = /{{(.*?)}}/g;